module.exports = __webpack_public_path__ + "img/video-bkp.453a277d.jpg";